import React, {Component} from "react";
import {Layout, Row, Col, Anchor, Table, message, Button} from "antd";
import {FilePdfTwoTone,ArrowLeftOutlined} from "@ant-design/icons";

import "../css/aiReportView.less"
import AxiosUtil from "../../utils/AxiosUtil";
import {AireportListProps, AireportViewProps, AireportYzyqProps} from "./model/aireport";
import DataUtil from "../../utils/DataUtil";
import SearchBar from "./components/SearchBar";
import NavHeader from "../../components/NavHeader";

const { Link } = Anchor;

interface IProps {
    match:any
}

export default class AiReportView extends Component<IProps> {

    state = {
        loading: false,
        mainData: {
            id: 0,
            task_id: 0,
            symbol: "",
            security_name: "",
            publish_date: "",
            pdf_url: "",
            create_time: "",
            flag: 0,
            security_spell: "",
            infoJson: "",
            companyInfo:"",
            catalyticAgentList: [],
            ybGlobalDOList:[],
            lightDOList:[],
            yzyqDOList: [],
        } as AireportViewProps,
        exColumns: [] as any[],
        peColumns: [] as any[],
        yzyqData: [],
        yzyqYear: "",

        todayTotal: 0,
        todayDate:""
    }

    componentDidMount() {
        this.loadSymbolData();
        const symbol = this.props.match.params.symbol;
        this.loadMainData(symbol || "");
    }

    render() {
        const searchCallback=(code:string)=>{
            window.location.replace('/#/ai-report/reportview/' + code)
            this.loadMainData(code);
        }
        const menuClick = (e: React.MouseEvent<HTMLElement>, link: {title: React.ReactNode; href: string; }) => {
            e.preventDefault();
            console.log(link);
        };

        console.log(this.props.match);
        // const url = this.props.match.url;
        return (
            <Layout className="body">
                <NavHeader />
                <div className={"ai-report"}>
                    <div className={"main"}>
                        <Row className={"home-bar"}>
                            <Col span={6}>
                                <a href="/#/ai-report/reportview/" title="返回首页" className={"back"} ><ArrowLeftOutlined /> 返回首页</a>
                            </Col>
                            <Col span={12}>
                                <SearchBar searchCallback={searchCallback} ></SearchBar>
                            </Col>
                            <Col span={6}>
                                <div className={"today-info"}>
                                    <p>最新智能研报日期：<span className={"blue"}>{this.state.todayDate}</span></p>
                                    <p>最近7天共有 <span className={"red"}>{this.state.todayTotal}</span> 只个股的智能研报</p>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                        <Col span={4} className={"menu"}>

                            <Anchor onClick={menuClick} offsetTop={36}>
                                <div className="title" >导读</div>
                                <Link href="#s1" title="股价催化剂" >
                                    <Link href="#s1-1" title="一致预期" />
                                </Link>
                                {this.state.mainData.ybGlobalDOList.length === 0 ? "" :
                                    <div>
                                        <Link href="#s2" title="研报核心观点">
                                            {this.state.mainData.ybGlobalDOList.map((rec: AireportListProps) => {
                                                return <Link key={rec.catalog_1} href={`#s2${rec.catalog_1}`} title={rec.catalog_1}/>
                                            })}
                                        </Link>
                                    </div>
                                }
                                {this.state.mainData.lightDOList.length === 0 ? "" :
                                    <Link href="#s3" title="研报掘金">
                                        {this.state.mainData.lightDOList.map((rec: AireportListProps) => {
                                            return <Link key={rec.catalog_1} href={`#s3${rec.catalog_1}`} title={rec.catalog_1}/>
                                        })}
                                    </Link>
                                }
                                <Link href="#s4" title="公司简介" />
                                <Button type={"link"} onClick={this.downloadPdf}  className="down"><FilePdfTwoTone twoToneColor="#40a9ff" /> 下载研报PDF</Button>
                            </Anchor>
                        </Col>
                        <Col span={20}>
                            <div className={"ai-content"}>
                                <p className={"title"}>{this.state.mainData.security_name}（{this.state.mainData.symbol}）研报掘金</p>
                                <div id={"s1"}>
                                    <p className={"title1"}>股价催化剂：</p>
                                    {this.state.mainData.catalyticAgentList.map((txt: string,idx:number) => {
                                        return <p key={idx}>{txt}</p>
                                    })}
                                    {
                                        (this.state.exColumns.every(item => item?.ex === '--') && this.state.peColumns.every(item => item?.pe === '--'))
                                        ? <></>
                                        : <div id={"s1-1"}>
                                            <p className={"title2"}>一致预期</p>
                                            <>
                                                {
                                                    (this.state.exColumns.every(item => item?.ex === '--'))
                                                    ? <></>
                                                    : <div>
                                                        <p>覆盖研究的券商对公司的 {this.state.yzyqYear} 年归母净利润预测区间如下：</p>
                                                        <Table key={"X1"}
                                                            columns={this.state.exColumns}
                                                            dataSource={this.state.yzyqData}
                                                            bordered
                                                            rowKey="year"
                                                            size="small"
                                                            pagination={false}
                                                        />
                                                    </div>
                                                }
                                            </>
                                            <>
                                                {
                                                    (this.state.peColumns.every(item => item?.pe === '--'))
                                                    ? <></>
                                                    : <div>
                                                        <p><br/>对应的 PE 最新一致预期如下：</p>
                                                        <Table key={"X2"}
                                                            columns={this.state.peColumns}
                                                            dataSource={this.state.yzyqData}
                                                            bordered
                                                            rowKey="year"
                                                            size="small"
                                                            pagination={false}
                                                        />
                                                    </div>
                                                }
                                            </>
                                        </div>
                                    }

                                </div>
                                {this.state.mainData.ybGlobalDOList.length === 0 ? "" :
                                    <div id={"s2"}>
                                        <p className={"title1"}>研报核心观点：</p>
                                        {this.state.mainData.ybGlobalDOList.map((rec: AireportListProps) => {
                                            return <div id={`s2${rec.catalog_1}`} key={rec.catalog_1}>
                                                {rec.content.split("\n").map((txt: string) => (<p>{txt}</p>))}
                                            </div>
                                        })}
                                    </div>
                                }
                                {this.state.mainData.lightDOList.length === 0 ? "" :
                                    <div id={"s3"}>
                                        <p className={"title1"}>研报掘金：</p>
                                        {this.state.mainData.lightDOList.map((rec: AireportListProps) => {
                                            return <div id={`s3${rec.catalog_1}`} key={rec.catalog_1}>
                                                {rec.content.split("\n").map((txt: string) => (<p>{txt}</p>))}
                                            </div>
                                        })}
                                    </div>
                                }
                                <div id={"s4"}>
                                    <p className={"title1"}>公司简介：</p>
                                    <p>{ this.state.mainData.companyInfo}</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    </div>
                </div>
            </Layout>
        )
    }
    downloadPdf = () => {
        let pdf_url = this.state.mainData.pdf_url;
        const callback2 = (suc: boolean, dat: any) => {
            if (suc) {
                window.location.href = dat;
                // let blobUrl = window.URL.createObjectURL(dat);
                // let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                // let filename = pdf_url.substr(pdf_url.lastIndexOf("/"));
                // aElement!.href = blobUrl;//设置a标签路径
                // aElement!.download = filename;
                // aElement!.click();
                // window.URL.revokeObjectURL(blobUrl);
            }
        }
        AxiosUtil.AxiosRequest('/api/pdf/getHwyPdf', {url:pdf_url}  , callback2);
    }
    loadSymbolData = () => {
        const callback2 = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({
                    todayTotal: dat.count,
                    todayDate: dat.publish_date
                });
            }
        }
        AxiosUtil.AxiosRequest('/api/ybTask/getTaskCount', {}  , callback2);
    }
    loadMainData = (symbol: string) => {
        this.setState({loading: true});
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                if (dat) {
                    const info = eval("(" + dat.infoJson + ")");
                    let myData = {...dat, infoJson2: undefined};
                    myData.catalyticAgentList = info.catalyticAgentList;
                    myData.companyInfo = info.companyInfo;
                    myData.ybGlobalDOList = info.ybGlobalDOList;
                    myData.lightDOList = info.lightDOList;
                    myData.yzyqDOList = info.yzyqDOList;

                    let exColumns: any = [];
                    let peColumns: any = [];
                    let yzyqData: any = {};
                    let miny = 0, maxy = 0;
                    info.yzyqDOList.forEach((rec: AireportYzyqProps) => {
                        exColumns.push({
                            title: rec.year,
                            key: rec.year,
                            dataIndex: "ex" + rec.year,
                            align: 'center' as 'center',
                            width: 200,
                            ex: rec.expt_enddate_fy
                        });
                        peColumns.push({
                            title: rec.year,
                            key: rec.year,
                            dataIndex: "pe" + rec.year,
                            align: 'center' as 'center',
                            width: 200,
                            pe: rec.pe
                        });
                        yzyqData["ex" + rec.year] = isNaN(Number(rec.expt_enddate_fy)) ? "--" : rec.expt_enddate_fy + "亿元";
                        yzyqData["pe" + rec.year] = rec.pe;
                        if (!isNaN(Number(rec.year))) {
                            if (miny == 0 || Number(rec.year) < miny)
                                miny = Number(rec.year);
                            if (maxy == 0 || Number(rec.year) > maxy)
                                maxy = Number(rec.year);
                        }
                    });
                    let yzyqYear = miny == maxy ? miny : miny + "-" + maxy;
                    console.log(exColumns)
                    console.log(peColumns)
                    console.log(yzyqData)
                    this.setState({
                        mainData: myData,
                        exColumns: exColumns,
                        peColumns: peColumns,
                        yzyqData: [yzyqData],
                        yzyqYear: yzyqYear
                    })
                } else {
                    message.error({content: '暂时还没有关于"' + symbol + '"的研报', className: 'message_error'});
                }
            }
            this.setState({loading: false});
        }
        AxiosUtil.AxiosRequest('/api/log/getPdfInfo', {'searchText': symbol}, callback);
    }
}
